import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from '../actions/user.actions';
import { GenesysCloudUsersState, initialState } from '../genesys-cloud-users.state';
import { userEntityAdapter } from '../adapters/user.adapter';

export const featureKey = 'genesysCloudUsers';

const reducer = createReducer(
  initialState(),
  on(Actions.actualUserLoaded, (state, { user }): GenesysCloudUsersState => ({
    ...state,
    user
  })),
  on(Actions.userLoaded, (state, { user }): GenesysCloudUsersState => ({
    ...state,
    users: userEntityAdapter.upsertOne(user, state.users)
  })
));

export function genesysCloudUsersReducer(state: GenesysCloudUsersState, action: Action): GenesysCloudUsersState {
  return reducer(state, action);
}
